import { InjectionToken } from '@angular/core';

import { environment } from 'src/environments/environment';

export interface MatomoConfig {
  allowedHosts: string[];
  disableCookies: boolean;
  enabled: boolean;
  siteId: string;
  trackSearch: boolean;
  trackerBaseUrl: string;
}

export const MATOMO_CONFIG = new InjectionToken<MatomoConfig | null>('MATOMO_CONFIG', {
  factory: (): MatomoConfig | null => {
    // Public builds supply an explicit configuration; other builds stay disabled.
    return (environment as typeof environment & { matomo?: MatomoConfig }).matomo || null;
  },
  providedIn: 'root',
});
